/**
 * src/data/legalContent.js — nội dung các trang tĩnh: giới thiệu, quyền riêng
 * tư, điều khoản.
 *
 * Viết theo đúng những gì phiên bản hiện tại THỰC SỰ làm. Khi bật đăng nhập,
 * lưu hồ sơ và tính phí ở giai đoạn 2, phải quay lại sửa file này TRƯỚC khi
 * mở tính năng — một chính sách mô tả sai việc mình đang làm còn tệ hơn không có.
 *
 * Tham chiếu: Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15 và Nghị định
 * 356/2025/NĐ-CP hướng dẫn, cùng có hiệu lực từ 01/01/2026 (thay Nghị định
 * 13/2023/NĐ-CP).
 */

export const CAP_NHAT = '2026-10-27';

export const PRIVACY = {
  slug: 'quyen-rieng-tu',
  title: 'Chính sách quyền riêng tư',
  tomTat:
    'Các phép tính chạy trên trình duyệt. Không đăng nhập thì dữ liệu chỉ nằm '
    + 'trên thiết bị của bạn. Đăng nhập là tuỳ chọn, để đồng bộ giữa các thiết bị '
    + 'hoặc gửi deck nhận xét. Đo lường ẩn danh chỉ chạy khi bạn bấm Đồng ý.',
  sections: [
    {
      h: 'Nguyên tắc',
      p: [
        'Toàn bộ công cụ dùng được mà không cần tài khoản. Chúng tôi không bắt đăng '
          + 'nhập để xem kết quả. Chúng tôi không bán dữ liệu và không đặt mã quảng '
          + 'cáo. Đo lường hành vi chỉ chạy khi bạn đồng ý, và kể cả khi đó, số liệu '
          + 'bạn nhập, tên công ty và email không bao giờ được gửi đi. Chi tiết ở mục '
          + 'Cookie và đo lường bên dưới.',
        'Chúng tôi chỉ lưu dữ liệu lên máy chủ khi bạn chủ động đăng nhập. Không đăng '
          + 'nhập thì dữ liệu bạn nhập vào công cụ, số liệu, bản nháp, checklist, '
          + 'không rời khỏi thiết bị. Như mọi website, hạ tầng lưu trữ vẫn ghi nhật ký '
          + 'truy cập kỹ thuật; phần này nêu ở mục Hạ tầng và nơi lưu trữ bên dưới.',
      ],
    },
    {
      h: 'Số liệu trong công cụ',
      p: [
        'Số liệu bạn nhập được xử lý trong trình duyệt. Kết quả tính ra không được gửi '
          + 'đi đâu để tính hộ. Trong cùng phiên sử dụng, dữ liệu được giữ khi chuyển '
          + 'trang để bạn tiếp tục công việc.',
        'Khi chọn lưu bản nháp, đánh dấu nguồn vốn hoặc tích checklist, website ghi dữ '
          + 'liệu vào bộ nhớ cục bộ của trình duyệt. Người dùng thiết bị và hồ sơ trình '
          + 'duyệt này có thể truy cập bản lưu.',
      ],
    },
    {
      h: 'Cookie và đo lường',
      id: 'cookie-va-do-luong',
      p: [
        'Lần đầu vào website, bạn được hỏi có cho phép đo lường ẩn danh hay không. '
          + 'Trước khi bạn bấm Đồng ý, website không tải công cụ đo lường nào và không '
          + 'đặt cookie đo lường. Từ chối thì mọi công cụ vẫn dùng đầy đủ. Bạn đổi lựa '
          + 'chọn lúc nào cũng được qua liên kết “Cài đặt cookie” ở chân trang; khi rút '
          + 'lại đồng ý, việc đo lường dừng và cookie đo lường trên trình duyệt được xoá.',
        'Khi bạn đồng ý, chúng tôi dùng ba công cụ. Google Analytics ghi nhận trang bạn '
          + 'xem và các thao tác như mở công cụ, lưu bản nháp, tải mẫu, đọc hết một bài '
          + 'viết hay bấm sang trang của quỹ; tính năng Google Signals và cá nhân hoá quảng '
          + 'cáo đã được tắt. Microsoft Clarity ghi lại cách bạn cuộn và bấm trên trang để '
          + 'chúng tôi thấy chỗ nào khó dùng; ở trang công cụ, Bản chuẩn bị và trang góp '
          + 'câu chuyện, toàn bộ nội dung bị che trong bản ghi, kể cả kết quả tính ra. Nhật '
          + 'ký nội bộ trên Firestore lưu cùng các thao tác đó để chúng tôi xem hành trình '
          + 'sử dụng trong trang quản trị.',
        'Những gì được gửi đi: đường dẫn trang (bỏ phần sau dấu ? và #), tên thao tác, '
          + 'mã công cụ hoặc mã mẫu liên quan, tên miền bạn bấm sang, nguồn dẫn bạn tới '
          + 'website (ví dụ Google hay Facebook), loại thiết bị, và một mã phiên ngẫu nhiên. '
          + 'Mã phiên của nhật ký nội bộ mất khi bạn đóng tab và không gắn với email hay tài '
          + 'khoản. Google và Microsoft có thể xử lý địa chỉ IP và thông tin trình duyệt để '
          + 'cung cấp dịch vụ, theo chính sách riêng của họ.',
        'Những gì không bao giờ được gửi đi: số liệu bạn nhập vào công cụ, kết quả tính '
          + 'ra, tên công ty, logo, email và nội dung bạn gõ vào ô tìm kiếm.',
        'Riêng lượt tải mẫu Excel được đếm cho mọi người, kể cả khi bạn từ chối: mỗi lượt '
          + 'chỉ ghi mã mẫu và thời điểm, không có thông tin nào về bạn.',
      ],
    },
    {
      h: 'Khi bạn chọn đăng nhập',
      p: [
        'Có hai cách đăng nhập, đều không dùng mật khẩu: nhận liên kết qua email, hoặc '
          + 'dùng tài khoản Google. Chúng tôi lưu địa chỉ email của bạn và một mã định '
          + 'danh tài khoản do Firebase Authentication cấp. Chúng tôi không lưu mật khẩu '
          + 'vì không có mật khẩu nào được tạo ra.',
        'Khi bạn chọn đăng nhập bằng Google, Google cho chúng tôi biết địa chỉ email và '
          + 'tên hiển thị trên tài khoản đó. Chúng tôi không xin và không nhận quyền truy '
          + 'cập vào Gmail, Drive, Danh bạ hay bất kỳ dữ liệu nào khác trong tài khoản '
          + 'Google của bạn. Việc Google xử lý thao tác đăng nhập tuân theo chính sách '
          + 'riêng của Google.',
        'Tài khoản dùng cho hai việc: đồng bộ Bản chuẩn bị giữa các thiết bị, và gửi '
          + 'pitch deck để nhận nhận xét (mục Nhận xét pitch deck bên dưới). Khi '
          + 'đã đăng nhập, toàn bộ Bản chuẩn bị, bản nháp công cụ, kịch bản đã lưu, '
          + 'checklist, nguồn vốn đã đánh dấu, hồ sơ startup tóm tắt gồm tên công ty và '
          + 'logo nếu bạn điền, được lưu vào một bản ghi riêng gắn với tài khoản bạn, '
          + 'trên Google Firestore. Quy tắc truy cập chỉ cho phép chính tài khoản đó đọc '
          + 'và ghi bản ghi của mình.',
        'Chúng tôi không xem dữ liệu này để phân tích, xếp hạng hay giới thiệu bạn cho '
          + 'bất kỳ quỹ nào. Không có tính năng nào cho phép quỹ đầu tư xem hồ sơ của bạn.',
        'Nếu bạn tích chọn nhận email cập nhật, chúng tôi dùng địa chỉ email đó để gửi '
          + 'thông báo về công cụ mới và thay đổi danh mục nguồn vốn. Bạn bỏ chọn lúc nào '
          + 'cũng được, ngay trong Bản chuẩn bị của tôi.',
      ],
    },
    {
      h: 'Logo và tài liệu',
      p: [
        'Logo bạn tải lên được thu nhỏ ngay trên máy bạn rồi lưu cùng Bản chuẩn bị. Nó '
          + 'không được xử lý bởi dịch vụ bên thứ ba nào.',
        'Ngoài logo, website chỉ nhận một loại tài liệu: pitch deck dạng PDF bạn chủ '
          + 'động gửi để nhận xét, theo cách xử lý ở mục ngay dưới đây. Website không nhận '
          + 'báo cáo tài chính hay tài liệu đính kèm nào khác.',
      ],
    },
    {
      h: 'Nhận xét pitch deck',
      id: 'nhan-xet-pitch-deck',
      p: [
        'Khi bạn gửi deck tại trang Nhận xét pitch deck, chúng tôi lưu: tệp PDF, email '
          + 'tài khoản, tên công ty và các thông tin bạn điền trong form (ngành, giai '
          + 'đoạn, vòng và số vốn định gọi, điều bạn muốn được góp ý). Tệp nằm trên '
          + 'Firebase Storage, thông tin nằm trên Firestore. Quy tắc truy cập chỉ cho '
          + 'phép bạn và quản trị của fundraising.vn đọc; quản trị chỉ mở deck khi cần '
          + 'xử lý lỗi hoặc kiểm tra chất lượng nhận xét.',
        'Nhận xét do AI thực hiện tự động. Nội dung deck và thông tin bạn điền được gửi '
          + 'tới dịch vụ AI Claude của Anthropic để nhận xét, đối chiếu với hướng dẫn đang '
          + 'đăng trên website, và kết quả được gửi thẳng cho bạn, không qua người đọc lại. '
          + 'Theo điều khoản thương mại của Anthropic, dữ liệu gửi qua API không được dùng '
          + 'để huấn luyện mô hình.',
        'Chúng tôi không chia sẻ deck hay nhận xét cho quỹ đầu tư hay bất kỳ bên nào '
          + 'khác, và không dùng deck của bạn làm ví dụ công khai. Chúng tôi dùng email '
          + 'của bạn để báo đã nhận deck và báo khi có nhận xét.',
        'Tệp deck tự xoá sau 90 ngày kể từ khi gửi nhận xét. Nhận xét được giữ trong '
          + 'tài khoản để bạn xem lại. Bạn xoá được cả tệp lẫn nhận xét bất cứ lúc nào '
          + 'ngay trên trang xem nhận xét.',
      ],
    },
    {
      h: 'Quyền của bạn và cách thực hiện',
      p: [
        'Xem và sửa: toàn bộ dữ liệu nằm ở trang Bản chuẩn bị của tôi, bạn xem và sửa '
          + 'trực tiếp.',
        'Lấy bản sao: nút “Xuất bản sao dữ liệu (.json)” tải về toàn bộ dữ liệu ở định '
          + 'dạng máy đọc được.',
        'Xoá: nút “Xoá tài khoản và dữ liệu” xoá bản ghi trên máy chủ rồi xoá tài khoản, '
          + 'không hoàn tác được. Nút “Xóa toàn bộ dữ liệu trên thiết bị” xoá bản lưu cục '
          + 'bộ. Hai việc này độc lập; bạn có thể làm một hoặc cả hai.',
        'Rút lại sự đồng ý: đăng xuất thì thiết bị ngừng đồng bộ. Muốn không còn dữ liệu '
          + 'trên máy chủ thì xoá tài khoản. Với đo lường, bấm “Cài đặt cookie” ở chân trang '
          + 'rồi chọn Từ chối.',
        'Khiếu nại hoặc yêu cầu khác về dữ liệu: xin-chao@fundraising.vn. Chúng tôi trả '
          + 'lời trong vòng 72 giờ làm việc.',
      ],
    },
    {
      h: 'Thời gian lưu',
      p: [
        'Dữ liệu gắn với tài khoản được giữ chừng nào tài khoản còn tồn tại. Tài khoản '
          + 'không đăng nhập trong 24 tháng liên tục sẽ được xoá cùng dữ liệu, sau khi '
          + 'chúng tôi gửi thông báo trước tới email đã đăng ký.',
        'Dữ liệu trên thiết bị do trình duyệt của bạn quản lý và tồn tại tới khi bạn xoá.',
        'Tệp pitch deck gửi nhận xét tự xoá sau 90 ngày kể từ khi gửi nhận xét; phần '
          + 'nhận xét giữ tới khi bạn xoá. Anthropic có thể lưu tạm nội dung gửi qua API '
          + 'trong thời gian ngắn để vận hành và chống lạm dụng, theo chính sách của họ.',
        'Nhật ký đo lường nội bộ tự xoá sau 180 ngày. Google Analytics giữ dữ liệu sự kiện '
          + 'theo thời hạn cài đặt cho tài khoản, tối đa 14 tháng. Microsoft Clarity giữ bản '
          + 'ghi phiên khoảng 30 ngày, trừ bản ghi được đánh dấu giữ lại để sửa lỗi.',
      ],
    },
    {
      h: 'Bên thứ ba và nơi lưu trữ',
      p: [
        'Website chạy trên Google Firebase: Hosting để phục vụ trang, Authentication cho '
          + 'việc đăng nhập, Firestore để lưu danh mục quỹ công khai, Bản chuẩn bị của '
          + 'người đã đăng nhập và yêu cầu nhận xét deck, Storage để lưu tệp deck, Cloud '
          + 'Functions để xử lý và gửi email thông báo. Dữ liệu được lưu trên hạ tầng của '
          + 'Google và có thể nằm ngoài lãnh thổ Việt Nam.',
        'Khi bạn gửi deck để nhận xét, nội dung deck được gửi tới Anthropic (dịch vụ AI '
          + 'Claude) như nêu ở mục Nhận xét pitch deck, và có thể được xử lý ngoài lãnh thổ '
          + 'Việt Nam.',
        'Hạ tầng lưu trữ có thể xử lý nhật ký truy cập như địa chỉ IP, đường dẫn và loại '
          + 'trình duyệt để vận hành và chống lạm dụng dịch vụ.',
        'Nếu bạn đồng ý đo lường, dữ liệu nêu ở mục Cookie và đo lường được gửi tới Google '
          + 'Analytics (Google) và Microsoft Clarity (Microsoft), có thể được xử lý ngoài lãnh '
          + 'thổ Việt Nam.',
        'Khi mở trang chính thức của quỹ hoặc chương trình, bạn truy cập website bên ngoài '
          + 'và chịu chính sách riêng của họ.',
      ],
    },
    {
      h: 'Cơ sở pháp lý và thay đổi',
      p: [
        'Chúng tôi xử lý dữ liệu cá nhân theo Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15 '
          + 'và Nghị định 356/2025/NĐ-CP. Cơ sở xử lý là sự '
          + 'đồng ý của bạn: với tài khoản, thể hiện qua việc bạn chủ động đăng nhập; với đo '
          + 'lường, thể hiện qua việc bạn bấm Đồng ý trên thông báo cookie; với nhận xét '
          + 'pitch deck, thể hiện qua ô đồng ý trên form gửi deck.',
        'Nếu bổ sung tính năng làm thay đổi cách xử lý dữ liệu, ví dụ chia sẻ thông tin '
          + 'với quỹ, chúng tôi sẽ cập nhật trang này và thông báo trước khi tính năng '
          + 'được bật.',
        'Chính sách này cập nhật lần gần nhất vào ngày ghi ở đầu trang. Câu hỏi về dữ '
          + 'liệu: xin-chao@fundraising.vn.',
      ],
    },
  ],
};

export const TERMS = {
  slug: 'dieu-khoan',
  title: 'Điều khoản sử dụng',
  tomTat:
    'Đây là công cụ tự tham khảo, miễn phí, không cần tài khoản. Không phải tư ' +
    'vấn đầu tư, không phải tư vấn pháp lý, và không đảm bảo kết quả gọi vốn.',
  sections: [
    {
      h: 'Kết quả chỉ mang tính tham khảo',
      p: [
        'Các con số công cụ đưa ra dựa hoàn toàn vào thông tin bạn nhập và các giả ' +
          'định được ghi rõ trong từng công cụ. Chúng tôi không thẩm định tính chính ' +
          'xác của thông tin bạn nhập.',
        'Điểm số cao không đồng nghĩa bạn sẽ gọi được vốn, và điểm thấp không có ' +
          'nghĩa doanh nghiệp bạn không đáng đầu tư. Quyết định đầu tư phụ thuộc vào ' +
          'rất nhiều yếu tố nằm ngoài phạm vi các công cụ này.',
      ],
    },
    {
      h: 'Không phải tư vấn chuyên môn',
      p: [
        'Nội dung trên website không phải tư vấn đầu tư, tư vấn tài chính, tư vấn ' +
          'thuế hay tư vấn pháp lý. Trước khi ký bất kỳ hợp đồng nào, thoả thuận ' +
          'đồng sáng lập, SAFE, hợp đồng đầu tư. Bạn nên tham vấn luật sư và kế ' +
          'toán có chuyên môn.',
        'Riêng với công cụ SAFE: điều khoản trong hợp đồng thực tế rất khác nhau ' +
          'giữa các bản. Công cụ nêu rõ các giả định nó dùng; bạn cần đối chiếu lại ' +
          'với hợp đồng của mình.',
      ],
    },
    {
      h: 'Thông tin về các quỹ đầu tư',
      p: [
        'Thông tin về quỹ đầu tư trên website được tổng hợp từ nguồn công khai, có ' +
          'ghi nguồn và ngày cập nhật. Chúng tôi không đại diện cho bất kỳ quỹ nào, ' +
          'không nhận phí giới thiệu từ startup, và việc một quỹ xuất hiện trên ' +
          'website không có nghĩa quỹ đó xác nhận hay liên kết với chúng tôi.',
      ],
    },
    {
      h: 'Tài khoản và dữ liệu của bạn',
      p: [
        'Tài khoản là tuỳ chọn và miễn phí, dùng để đồng bộ Bản chuẩn bị giữa các thiết '
          + 'bị và gửi pitch deck để nhận xét. Bạn chịu trách nhiệm với hộp thư dùng để đăng nhập: ai truy cập được hộp '
          + 'thư đó thì đăng nhập được vào tài khoản này.',
        'Dữ liệu trong Bản chuẩn bị là của bạn. Chúng tôi không dùng nó cho mục đích nào '
          + 'ngoài việc đồng bộ, không chia sẻ với quỹ đầu tư hay bên thứ ba, và không '
          + 'dùng để huấn luyện mô hình. Cách xử lý cụ thể ghi trong Chính sách quyền '
          + 'riêng tư.',
        'Bạn xoá được tài khoản và dữ liệu bất cứ lúc nào ngay trong Bản chuẩn bị của tôi. '
          + 'Chúng tôi có thể tạm ngưng hoặc xoá tài khoản có dấu hiệu lạm dụng dịch vụ, '
          + 'sau khi thông báo tới email đăng ký trừ khi việc thông báo làm tăng thiệt hại.',
        'Đồng bộ là tiện ích, không phải dịch vụ sao lưu. Hãy tự giữ bản sao bằng nút xuất '
          + 'dữ liệu nếu số liệu đó quan trọng với bạn.',
      ],
    },
    {
      h: 'Nội dung bạn tải lên',
      p: [
        'Khi tải logo lên, bạn xác nhận mình có quyền sử dụng hình ảnh đó. Bạn giữ toàn bộ '
          + 'quyền với logo và dữ liệu của mình; chúng tôi chỉ lưu và hiển thị lại cho '
          + 'chính bạn, kể cả trên file bạn xuất ra.',
        'File bạn xuất ra, bản tóm tắt một trang, bảng Excel, là của bạn, dùng và gửi đi '
          + 'tuỳ ý. Chúng tôi không giữ bản sao và không biết bạn gửi cho ai.',
      ],
    },
    {
      h: 'Nhận xét pitch deck',
      p: [
        'Khi gửi deck, bạn xác nhận mình có quyền chia sẻ nội dung trong deck. Bạn giữ toàn '
          + 'bộ quyền với deck; chúng tôi chỉ dùng nó để nhận xét cho chính bạn.',
        'Nhận xét do AI soạn tự động, là góc nhìn tham khảo, có thể sai hoặc thiếu; không '
          + 'phải đánh giá của quỹ đầu tư và không đảm bảo kết quả gọi vốn. Dịch vụ miễn phí, '
          + 'mỗi tài khoản tối đa 2 lần nhận xét trong 7 ngày, và thời gian trả nhận xét '
          + '(thường 15 đến 30 phút) là mục tiêu, không phải cam kết.',
        'Chúng tôi có thể từ chối nhận xét deck không phải pitch deck, deck có nội dung vi '
          + 'phạm pháp luật, hoặc tài khoản gửi lặp lại để lạm dụng dịch vụ.',
      ],
    },
    {
      h: 'Giới hạn trách nhiệm',
      p: [
        'Website được cung cấp nguyên trạng. Chúng tôi cố gắng làm cho các phép ' +
          'tính chính xác và có bộ kiểm thử tự động, nhưng không đảm bảo website ' +
          'không có lỗi hay luôn sẵn sàng. Chúng tôi không chịu trách nhiệm cho ' +
          'thiệt hại phát sinh từ việc bạn sử dụng hoặc không sử dụng được website.',
        'Nếu bạn phát hiện một phép tính cho kết quả sai, hãy báo cho chúng tôi. ' +
          'Đó là loại phản hồi có giá trị nhất.',
      ],
    },
  ],
};

export const ABOUT = {
  slug: 'gioi-thieu',
  title: 'Giới thiệu',
  showDate: false,
  tomTat:
    'Bộ công cụ miễn phí giúp người khởi nghiệp lần đầu chuẩn bị hồ sơ trước ' +
    'khi gọi vốn vòng angel hoặc pre-seed.',
  sections: [
    {
      h: 'Vì sao có website này',
      p: [
        'Người gọi vốn lần đầu ở Việt Nam gặp một vấn đề rất cụ thể: các công cụ ' +
          'và tài liệu tốt đều bằng tiếng Anh và viết cho thị trường Mỹ. Chia cổ ' +
          'phần thế nào, vesting là gì, SAFE mình vừa ký thực sự lấy đi bao nhiêu ' +
          'phần trăm, hồ sơ pháp lý cần những gì, đó là những câu hỏi rất khó tìm ' +
          'câu trả lời tử tế bằng tiếng Việt.',
        'Các công cụ ở đây trả lời đúng những câu hỏi đó, bằng tiếng Việt, ' +
          'theo bối cảnh pháp lý và thị trường vốn Việt Nam.',
      ],
    },
    {
      h: 'Website này làm gì',
      p: [
        'Mỗi công cụ nhận vài thông tin bạn nhập vào, tính ra con số, và quan ' +
          'trọng hơn là chỉ ra rủi ro trong cách bạn đang làm, kèm giải thích vì ' +
          'sao nhà đầu tư quan tâm điều đó và nên xử lý thế nào.',
        'Toàn bộ phép tính chạy trên trình duyệt của bạn và không cần tài khoản. ' +
          'Nếu muốn dùng trên nhiều thiết bị, bạn có thể đăng nhập bằng email để ' +
          'đồng bộ Bản chuẩn bị, đó là lần duy nhất dữ liệu rời khỏi máy bạn, và ' +
          'chỉ khi bạn chủ động chọn.',
      ],
    },
    {
      h: 'Website này không làm gì',
      p: [
        'Không tư vấn đầu tư, không tư vấn pháp lý, không đảm bảo kết quả gọi vốn. ' +
          'Điểm cao không có nghĩa bạn sẽ gọi được vốn, và điểm thấp không có nghĩa ' +
          'doanh nghiệp bạn không đáng đầu tư.',
        'Không đại diện cho quỹ nào và không nhận phí giới thiệu từ người khởi ' +
          'nghiệp. Việc một quỹ xuất hiện trên website không có nghĩa quỹ đó xác ' +
          'nhận hay liên kết với chúng tôi.',
        'Không có quảng cáo và không có mã theo dõi.',
      ],
    },
    {
      h: 'Thông tin về quỹ được thu thập thế nào',
      p: [
        'Mỗi quỹ chỉ được thêm vào sau khi đối chiếu với trang chính thức của họ. ' +
          'Trường nào quỹ không công bố thì để trống, không suy đoán, vì một con ' +
          'số ticket size sai khiến bạn hoặc gửi hồ sơ vào chỗ chắc chắn bị từ ' +
          'chối, hoặc bỏ qua quỹ vốn dĩ phù hợp.',
        'Mỗi mục đều ghi nguồn và ngày kiểm chứng gần nhất. Danh sách đang được ' +
          'mở rộng dần và chưa phải toàn bộ thị trường.',
      ],
    },
    {
      h: 'Góp ý và báo lỗi',
      p: [
        'Nếu bạn phát hiện một phép tính cho kết quả sai, hoặc thông tin về một ' +
          'quỹ không còn đúng, hãy báo cho chúng tôi. Đó là loại phản hồi có giá ' +
          'trị nhất.',
        // TODO: thay bằng địa chỉ email thật trước khi mở public.
        'Liên hệ: xin-chao@fundraising.vn',
      ],
    },
  ],
};

export const TRANG_TINH = [ABOUT, PRIVACY, TERMS];

/** Giữ tên cũ để không phải sửa nơi khác cùng lúc. */
export const LEGAL_PAGES = TRANG_TINH;

export function legalBySlug(slug) {
  return TRANG_TINH.find((p) => p.slug === slug) || null;
}
